export function setBrand(brand){
  return{type:'SET_BRAND', brand}
}

export function setHome(brand){
  return{type:'SET_HOME', brand}
}
